import { render, staticRenderFns } from "./OutageHistory.vue?vue&type=template&id=45db6ec8&scoped=true"
import script from "./OutageHistory.vue?vue&type=script&lang=js"
export * from "./OutageHistory.vue?vue&type=script&lang=js"
import style0 from "./OutageHistory.vue?vue&type=style&index=0&id=45db6ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db6ec8",
  null
  
)

export default component.exports